<template>
  <div
    class="progress-bar">
    <div class="progress-bar__progress" :style="style"></div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import LinkBuildingItem from './LinkBuildingItem'

/**
   * Stylized progressbar for {@link LinkBuildingItem}
   */
export default {
  name: 'LinkProgressBar',
  props: {
    percent: {
      default: 0
    }
  },
  computed: {
    style () {
      return {
        'flex-basis': `${this.percent}%`
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .progress-bar {
    display: flex;
    background-color: $rfx-light-emerald;
    height: 10px;
    border-radius: 5px;

    &__progress {
      flex: 0 0;
      flex-basis: 50%;
      background-color: $rfx-emerald;
      border-radius: 5px;
    }
  }
</style>
